// @flow

import {Avatar, Chip, makeStyles} from '@material-ui/core';
import React from 'react';

import {getImageUrl} from '../../../../../utils/image_provider';
import type {
  ProductVariantOptionValue,
  ProductVariantOptionDisplayType,
  ProductVariantOptionImageShape,
} from '../../../../../entities';

type Props = {
  vov: ProductVariantOptionValue,
  onDelete: () => void,
  displayType: ProductVariantOptionDisplayType,
  imageShape: ProductVariantOptionImageShape,
};

const useStyles = props =>
  makeStyles(theme => ({
    // chip: {
    //   paddingLeft: theme.spacing(1),
    //   paddingRight: theme.spacing(1),
    // },
    colorWrap: {
      width: 18,
      height: 18,
      borderRadius: props.circular ? '50%' : undefined,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  }));

export const ProductVariantOptionValueChip = ({
  vov,
  onDelete,
  displayType,
  imageShape,
}: Props) => {
  const classes = useStyles({circular: imageShape === 'CIRCULAR'})();

  const isColor = displayType === 'COLOR';

  const buildAvatar = () => {
    if (isColor)
      return (
        <div
          className={classes.colorWrap}
          style={{backgroundColor: vov.color}}
        ></div>
      );
    return vov.imageId ? <Avatar src={getImageUrl(vov.imageId)} /> : null;
  };

  return (
    <Chip
      classes={{
        root: classes.chip,
      }}
      variant="outlined"
      label={vov.label}
      onDelete={onDelete}
      avatar={buildAvatar()}
    />
  );
};
